import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./surveyForm.css";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function MFISurveyForm() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [direction, setDirection] = useState("next");
  const [isVerifying, setIsVerifying] = useState(null);
  const [mfis, setMFIs] = useState([]);
  const [mfiID, setMfiID] = useState();
  const [operation, setOperation] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [locationName, setLocationName] = useState(null);
  const [subward, setSubward] = useState(null);
  const [ward, setWard] = useState(null);
  const [city, setCity] = useState(null);
  const [region, setRegion] = useState(null);
  const [postcode, setPostcode] = useState(null);
  const [country, setCountry] = useState(null);
  const [countryCode, setCountryCode] = useState(null);
  const [mfiPhoto, setMFIPhoto] = useState(null);
  const [cir, setCIR] = useState(null);
  const [totalCustomers, setTotalCustomers] = useState(null);
  const [branches, setBranches] = useState(null);
  const [submitBOTReport, setSubmitBOTReport] = useState("");
  const [coverage, setCoverage] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [dataSubmission, setDataSubmission] = useState("");
  const [submitDataBoth, setSubmitDataBoth] = useState("");
  const [noSubmissionReason, setNoSubmissionReason] = useState([]);
  const [crbLoanAssess, setCRBLoanAssess] = useState("");
  const [assessDataBoth, setAssessDataBoth] = useState("");
  const [noLoanAssessReason, setNoLoanAssessReason] = useState([]);
  const [tamfiMember, setTamfiMember] = useState("");
  const [notInTAMFIReason, setNotInTAMFIReason] = useState([]);
  const [interest, setInterest] = useState(null);
  const [financialAccount, setFinancialAccount] = useState("");
  const [banks, setBanks] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [isFetchingLocation, setIsFetchingLocation] = useState(false);
  const [haveDPC, setHaveDPC] = useState("");
  const [dpc, setDPC] = useState(null);

  useEffect(() => {
    const fetchMFIs = async () => {
      try {
        const response = await axios.get("/api/getAllMFIs");
        setMFIs(response.data);
      } catch (error) {
        console.error("Error fetching mfis:", error);
      }
    };
    fetchMFIs();
  }, []);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await axios.get("/api/getAllBanks");
        setBanks(response.data);
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };
    fetchBanks();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("/api/getAllProducts");
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  async function fetchLocation(e) {
    e.preventDefault();
    setIsFetchingLocation(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          setLatitude(coords.latitude);
          setLongitude(coords.longitude);

          axios
            .get("/api/getLocationName", {
              params: {
                latitude: coords.latitude,
                longitude: coords.longitude,
              },
            })
            .then((response) => {
              //console.log(response.data);
              setLocationName(response.data.displayName);
              setSubward(response.data.address.subward);
              setWard(response.data.address.ward);
              setCity(response.data.address.city);
              setRegion(response.data.address.region);
              setPostcode(response.data.address.postcode);
              setCountry(response.data.address.country);
              setCountryCode(response.data.address.country_code);
            })
            .catch(() => {
              toast.error("Error fetching location name.", {
                position: toast.POSITION.TOP_RIGHT,
              });
            });

          setIsFetchingLocation(false);
        },
        (error) => {
          toast.error("Unable to fetch location. Please enable GPS.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsFetchingLocation(false);
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 },
      );
    } else {
      toast.error("Geolocation is not supported by this browser.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setIsFetchingLocation(false);
    }
  }

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setSelectedProducts((prev) => [...prev, value]);
    } else {
      setSelectedProducts((prev) => prev.filter((item) => item !== value));
    }
  };

  const handleCheckboxSubmissionReasonChange = (event) => {
    const { value, checked } = event.target;

    setNoSubmissionReason((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value),
    );
  };

  const handleCheckboxLoanAssessReasonChange = (event) => {
    const { value, checked } = event.target;

    setNoLoanAssessReason((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value),
    );
  };

  const handleCheckboxNotInTAMFIReasonChange = (event) => {
    const { value, checked } = event.target;

    setNotInTAMFIReason((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value),
    );
  };

  // Add another empty select
  const addInstitution = () => {
    setInstitutions([...institutions, ""]);
  };

  // Update value when a select changes
  const handleChangeInstitution = (index, value) => {
    const updated = [...institutions];
    updated[index] = value;
    setInstitutions(updated);
  };

  // Remove a select at given index
  const removeInstitution = (index) => {
    const updated = institutions.filter((_, i) => i !== index);
    setInstitutions(updated.length > 0 ? updated : [""]); // keep at least one
  };

  const handleSubmitSurveyInfo = async (e) => {
    e.preventDefault();
    setIsVerifying(true);
    const formData = new FormData();
    formData.append("mfiID", mfiID);
    formData.append("stillOperating", operation);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    formData.append("mfiPhoto", mfiPhoto);
    formData.append("cir", cir);
    formData.append("totalCustomers", totalCustomers);
    formData.append("branches", branches);
    formData.append("botSubmission", submitBOTReport);
    formData.append("coverage", coverage);
    selectedProducts.forEach((product, index) => {
      formData.append(`products[${index}]`, product);
    });
    formData.append("submitData", dataSubmission);
    formData.append("submitDataBothCRB", submitDataBoth);
    noSubmissionReason.forEach((reason, index) => {
      formData.append(`noSubmissionReason[${index}]`, reason);
    });
    formData.append("crbLoanAssess", crbLoanAssess);
    formData.append("loanAssessBothCRB", assessDataBoth);
    noLoanAssessReason.forEach((reason, index) => {
      formData.append(`noLoanAssessReason[${index}]`, reason);
    });
    formData.append("tamfiTamiuMember", tamfiMember);
    notInTAMFIReason.forEach((reason, index) => {
      formData.append(`notInTAMFIReason[${index}]`, reason);
    });
    formData.append("interestRate", interest);
    formData.append("financialAccount", financialAccount);
    institutions.forEach((institution, index) => {
      formData.append(`institutions[${index}]`, institution);
    });
    formData.append("locationName", locationName);
    formData.append("subward", subward);
    formData.append("ward", ward);
    formData.append("city", city);
    formData.append("region", region);
    formData.append("postcode", postcode);
    formData.append("country", country);
    formData.append("countryCode", countryCode);
    formData.append("haveDPC", haveDPC);
    formData.append("dpc", dpc);
    axios
      .post("/api/newSurveyInfo", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setIsVerifying(false);
        navigate("/success-message");
      })
      .catch((error) => {
        setIsVerifying(false);
        toast.error("Error submitting survey. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const goNext = () => {
    setDirection("next");
    setStep((s) => Math.min(s + 1, 5));
  };

  const goPrev = () => {
    setDirection("prev");
    setStep((s) => Math.max(s - 1, 1));
  };
  return (
    <div className="mfi-survey-container">
      <header className="survey-form-header">
        <h1>MICROFINANCE SURVEY FORM</h1>
      </header>

      <form className="survey-form" onSubmit={handleSubmitSurveyInfo}>
        {/* Step Wrapper */}
        <div className={`form-step ${step === 1 ? `active ${direction}` : ""}`}>
          <div className="survey-form-group">
            <label>
              MFI Subscriber Name <span className="star">*</span>
            </label>
            <select
              required
              value={mfiID}
              onChange={(e) => setMfiID(e.target.value)}
            >
              <option value="">Choose MFI</option>
              {mfis.map((mfi) => (
                <option key={mfi.id} value={mfi.id}>
                  {mfi.mfi_name}
                </option>
              ))}
            </select>
          </div>
          <div className="survey-form-group">
            <label>
              Are you still in operation ? <span className="star">*</span>
            </label>
            <div className="radio-div">
              <div className="radio-wrapper-3">
                <label htmlFor="radio-operation-yes">
                  <input
                    id="radio-operation-yes"
                    type="radio"
                    name="radio-operation"
                    value="Yes"
                    checked={operation === "Yes"}
                    onChange={(e) => setOperation(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>Yes</span>
                </label>
              </div>
              <div className="radio-wrapper-3">
                <label htmlFor="radio-operation-no">
                  <input
                    id="radio-operation-no"
                    type="radio"
                    name="radio-operation"
                    value="No"
                    checked={operation === "No"}
                    onChange={(e) => setOperation(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>No</span>
                </label>
              </div>
            </div>
          </div>
          <div className="survey-form-group">
            <label>
              Latitude Cord. <span className="star">*</span>
            </label>
            <input type="text" value={latitude} required disabled />
          </div>

          <div className="survey-form-group">
            <label>
              Longitude Cord. <span className="star">*</span>
            </label>
            <input type="text" value={longitude} required disabled />
          </div>

          <div className="survey-form-group">
            <label>Location Name</label>
            <input type="text" value={locationName} disabled />
          </div>

          <button
            type="button"
            onClick={fetchLocation}
            disabled={isFetchingLocation}
            className="fetch-location-btn"
          >
            {isFetchingLocation ? (
              <div className="overlay">
                <img
                  src="images/location.png"
                  alt="Loading..."
                  className="survey-loading-logo"
                />
              </div>
            ) : (
              "Fetch Location"
            )}
          </button>

          <div className="survey-form-group">
            <label>
              Upload Image <span className="option">(Optional)</span>
            </label>
            <input
              type="file"
              name="mfiPhoto"
              onChange={(e) => setMFIPhoto(e.target.files[0])}
            />
          </div>
        </div>

        <div className={`form-step ${step === 2 ? `active ${direction}` : ""}`}>
          <div className="survey-form-group">
            <label>
              What is your Cost to Income Ratio (CIR) in <b>(%)</b> ?{" "}
              <span className="option">(Optional)</span>
            </label>
            <input
              type="number"
              name="cir"
              value={cir ?? ""}
              onChange={(e) =>
                setCIR(e.target.value === "" ? null : Number(e.target.value))
              }
            />
          </div>
          <div className="survey-form-group">
            <label>
              What is the total number of your customers ?{" "}
              <span className="star">*</span>
            </label>
            <input
              type="text"
              name="totalCustomers"
              value={totalCustomers}
              onChange={(e) => setTotalCustomers(e.target.value)}
              required
            />
          </div>
          <div className="survey-form-group">
            <label>
              In how many branches do you operate ?{" "}
              <span className="star">*</span>
            </label>
            <input
              type="text"
              name="branches"
              value={branches}
              onChange={(e) => setBranches(e.target.value)}
              required
            />
          </div>
          <div className="survey-form-group">
            <label>
              Do you submit BOT monthly report ? <span className="star">*</span>
            </label>
            <div className="radio-div">
              <div className="radio-wrapper-3">
                <label htmlFor="radio-bot-report-yes">
                  <input
                    id="radio-bot-report-yes"
                    type="radio"
                    name="radio-bot-report"
                    value="Yes"
                    checked={submitBOTReport === "Yes"}
                    onChange={(e) => setSubmitBOTReport(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>Yes</span>
                </label>
              </div>
              <div className="radio-wrapper-3">
                <label htmlFor="radio-bot-report-no">
                  <input
                    id="radio-bot-report-no"
                    type="radio"
                    name="radio-bot-report"
                    value="No"
                    checked={submitBOTReport === "No"}
                    onChange={(e) => setSubmitBOTReport(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>No</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className={`form-step ${step === 3 ? `active ${direction}` : ""}`}>
          <div className="survey-form-group">
            <label>
              What is your coverage ? <span className="star">*</span>
            </label>
            <div className="radio-div">
              <div className="radio-wrapper-3">
                <label htmlFor="radio-coverage-national">
                  <input
                    id="radio-coverage-national"
                    type="radio"
                    name="radio-coverage"
                    value="National"
                    checked={coverage === "National"}
                    onChange={(e) => setCoverage(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>National</span>
                </label>
              </div>
              <div className="radio-wrapper-3">
                <label htmlFor="radio-coverage-local">
                  <input
                    id="radio-coverage-local"
                    type="radio"
                    name="radio-coverage"
                    value="Local"
                    checked={coverage === "Local"}
                    onChange={(e) => setCoverage(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>Local</span>
                </label>
              </div>
            </div>
          </div>

          <div className="survey-form-group">
            <label>
              What types of products do you offer ?{" "}
              <span className="star">*</span>
            </label>

            <div className="check-div">
              {products.map((product) => (
                <div className="checkbox-wrapper-1" key={product.id}>
                  <input
                    id={product.product_name.toLowerCase().replace(/\s+/g, "-")}
                    className="substituted"
                    type="checkbox"
                    aria-hidden="true"
                    value={product.id}
                    checked={selectedProducts.includes(product.id)}
                    onChange={handleCheckboxChange}
                  />
                  <label
                    htmlFor={product.product_name
                      .toLowerCase()
                      .replace(/\s+/g, "-")}
                  >
                    {product.product_name}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="survey-form-group">
            <label>
              Do you submit borrowers' information to CRB ?{" "}
              <span className="star">*</span>
            </label>
            <div className="radio-div">
              <div className="radio-wrapper-3">
                <label htmlFor="radio-borrower-yes">
                  <input
                    id="radio-borrower-yes"
                    type="radio"
                    name="radio-borrower"
                    value="Yes"
                    checked={dataSubmission === "Yes"}
                    onChange={(e) => setDataSubmission(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>Yes</span>
                </label>
              </div>
              <div className="radio-wrapper-3">
                <label htmlFor="radio-borrower-no">
                  <input
                    id="radio-borrower-no"
                    type="radio"
                    name="radio-borrower"
                    value="No"
                    checked={dataSubmission === "No"}
                    onChange={(e) => setDataSubmission(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>No</span>
                </label>
              </div>
            </div>
          </div>
          {dataSubmission === "Yes" && (
            <div className="survey-form-group">
              <label>
                Do you submit to both bureaus ? <span className="star">*</span>
              </label>
              <div className="radio-div">
                <div className="radio-wrapper-3">
                  <label htmlFor="radio-submit-both-yes">
                    <input
                      id="radio-submit-both-yes"
                      type="radio"
                      name="radio-submit-both"
                      value="Yes"
                      checked={submitDataBoth === "Yes"}
                      onChange={(e) => setSubmitDataBoth(e.target.value)}
                    />
                    <span className="circle"></span>
                    <span>Yes</span>
                  </label>
                </div>
                <div className="radio-wrapper-3">
                  <label htmlFor="radio-submit-both-no">
                    <input
                      id="radio-submit-both-no"
                      type="radio"
                      name="radio-submit-both"
                      value="No"
                      checked={submitDataBoth === "No"}
                      onChange={(e) => setSubmitDataBoth(e.target.value)}
                    />
                    <span className="circle"></span>
                    <span>No</span>
                  </label>
                </div>
              </div>
            </div>
          )}
          {dataSubmission === "No" && (
            <div className="survey-form-group">
              <label>
                Kindly choose at least one reason{" "}
                <span className="star">*</span>
              </label>
              <div className="check-div">
                <div className="checkbox-wrapper-1">
                  <input
                    id="awareness"
                    className="substituted"
                    type="checkbox"
                    value="Lack of awareness"
                    checked={noSubmissionReason.includes("Lack of awareness")}
                    onChange={handleCheckboxSubmissionReasonChange}
                  />
                  <label for="awareness">Lack of awareness</label>
                </div>
                <div class="checkbox-wrapper-1">
                  <input
                    id="enforcement"
                    className="substituted"
                    type="checkbox"
                    value="Weak of enforcement of the law"
                    checked={noSubmissionReason.includes(
                      "Weak of enforcement of the law",
                    )}
                    onChange={handleCheckboxSubmissionReasonChange}
                  />
                  <label for="enforcement">
                    Weak of enforcement of the law
                  </label>
                </div>
              </div>
              <div className="check-div">
                <div class="checkbox-wrapper-1">
                  <input
                    id="working-tool"
                    className="substituted"
                    type="checkbox"
                    value="Lack of working tool"
                    checked={noSubmissionReason.includes(
                      "Lack of working tool",
                    )}
                    onChange={handleCheckboxSubmissionReasonChange}
                  />
                  <label for="working-tool">Lack of working tool</label>
                </div>
                <div class="checkbox-wrapper-1">
                  <input
                    id="eliterate"
                    className="substituted"
                    type="checkbox"
                    value="Eliterate in computer knowledge"
                    checked={noSubmissionReason.includes(
                      "Eliterate in computer knowledge",
                    )}
                    onChange={handleCheckboxSubmissionReasonChange}
                  />
                  <label for="eliterate">Eliterate in computer knowledge</label>
                </div>
              </div>
              <div className="check-div">
                <div class="checkbox-wrapper-1">
                  <input
                    id="disclose-clients"
                    className="substituted"
                    type="checkbox"
                    value="Doesn't need to disclose clients info."
                    checked={noSubmissionReason.includes(
                      "Doesn't need to disclose clients info.",
                    )}
                    onChange={handleCheckboxSubmissionReasonChange}
                  />
                  <label for="disclose-clients">
                    Doesn't need to disclose clients info.
                  </label>
                </div>
                <div class="checkbox-wrapper-1">
                  <input
                    id="other"
                    className="substituted"
                    type="checkbox"
                    value="Other"
                    checked={noSubmissionReason.includes("Other")}
                    onChange={handleCheckboxSubmissionReasonChange}
                  />
                  <label for="other">Other</label>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={`form-step ${step === 4 ? `active ${direction}` : ""}`}>
          <div className="survey-form-group">
            <label>
              Do you use CRB reports for loan assessment ?{" "}
              <span className="star">*</span>
            </label>
            <div className="radio-div">
              <div className="radio-wrapper-3">
                <label htmlFor="radio-loan-assess-Yes">
                  <input
                    id="radio-loan-assess-Yes"
                    type="radio"
                    name="radio-loan-assess"
                    value="Yes"
                    checked={crbLoanAssess === "Yes"}
                    onChange={(e) => setCRBLoanAssess(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>Yes</span>
                </label>
              </div>
              <div className="radio-wrapper-3">
                <label htmlFor="radio-loan-assess-No">
                  <input
                    id="radio-loan-assess-No"
                    type="radio"
                    name="radio-loan-assess"
                    value="No"
                    checked={crbLoanAssess === "No"}
                    onChange={(e) => setCRBLoanAssess(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>No</span>
                </label>
              </div>
            </div>
          </div>
          {crbLoanAssess === "Yes" && (
            <div className="survey-form-group">
              <label>
                Do you assess using both bureaus ?{" "}
                <span className="star">*</span>
              </label>
              <div className="radio-div">
                <div className="radio-wrapper-3">
                  <label htmlFor="radio-assess-both-yes">
                    <input
                      id="radio-assess-both-yes"
                      type="radio"
                      name="radio-assess-both"
                      value="Yes"
                      checked={assessDataBoth === "Yes"}
                      onChange={(e) => setAssessDataBoth(e.target.value)}
                    />
                    <span className="circle"></span>
                    <span>Yes</span>
                  </label>
                </div>
                <div className="radio-wrapper-3">
                  <label htmlFor="radio-assess-both-no">
                    <input
                      id="radio-assess-both-no"
                      type="radio"
                      name="radio-assess-both"
                      value="No"
                      checked={assessDataBoth === "No"}
                      onChange={(e) => setAssessDataBoth(e.target.value)}
                    />
                    <span className="circle"></span>
                    <span>No</span>
                  </label>
                </div>
              </div>
            </div>
          )}
          {crbLoanAssess === "No" && (
            <div className="survey-form-group">
              <label>
                Kindly choose atleast one reason <span className="star">*</span>
              </label>
              <div className="check-div">
                <div class="checkbox-wrapper-1">
                  <input
                    id="price"
                    class="substituted"
                    type="checkbox"
                    value="High Price"
                    checked={noLoanAssessReason.includes("High Price")}
                    onChange={handleCheckboxLoanAssessReasonChange}
                  />
                  <label for="price">High Price</label>
                </div>
                <div class="checkbox-wrapper-1">
                  <input
                    id="lack-awareness"
                    class="substituted"
                    type="checkbox"
                    value="Lack of awareness"
                    checked={noLoanAssessReason.includes("Lack of awareness")}
                    onChange={handleCheckboxLoanAssessReasonChange}
                  />
                  <label for="lack-awareness">Lack of awareness</label>
                </div>
              </div>
              <div className="check-div">
                <div class="checkbox-wrapper-1">
                  <input
                    id="consent"
                    class="substituted"
                    type="checkbox"
                    value="Lack of consent"
                    checked={noLoanAssessReason.includes("Lack of consent")}
                    onChange={handleCheckboxLoanAssessReasonChange}
                  />
                  <label for="consent">Lack of consent</label>
                </div>
                <div class="checkbox-wrapper-1">
                  <input
                    id="database"
                    class="substituted"
                    type="checkbox"
                    value="Incomplete database"
                    checked={noLoanAssessReason.includes("Incomplete database")}
                    onChange={handleCheckboxLoanAssessReasonChange}
                  />
                  <label for="database">Incomplete database</label>
                </div>
              </div>
              <div className="check-div">
                <div class="checkbox-wrapper-1">
                  <input
                    id="another-join"
                    class="substituted"
                    type="checkbox"
                    value="Want to see another join"
                    checked={noLoanAssessReason.includes(
                      "Want to see another join",
                    )}
                    onChange={handleCheckboxLoanAssessReasonChange}
                  />
                  <label for="another-join">Want to see another join</label>
                </div>
                <div class="checkbox-wrapper-1">
                  <input
                    id="assessment-other"
                    class="substituted"
                    type="checkbox"
                    value="Other"
                    checked={noLoanAssessReason.includes("Other")}
                    onChange={handleCheckboxLoanAssessReasonChange}
                  />
                  <label for="assessment-other">Other</label>
                </div>
              </div>
            </div>
          )}
          <div className="survey-form-group">
            <label>
              Are you a member of TAMFI or TAMIU ?{" "}
              <span className="star">*</span>
            </label>
            <div className="radio-div">
              <div className="radio-wrapper-3">
                <label htmlFor="radio-tamfi-Yes">
                  <input
                    id="radio-tamfi-Yes"
                    type="radio"
                    name="radio-tamfi"
                    value="Yes"
                    checked={tamfiMember === "Yes"}
                    onChange={(e) => setTamfiMember(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>Yes</span>
                </label>
              </div>
              <div className="radio-wrapper-3">
                <label htmlFor="radio-tamfi-No">
                  <input
                    id="radio-tamfi-No"
                    type="radio"
                    name="radio-tamfi"
                    value="No"
                    checked={tamfiMember === "No"}
                    onChange={(e) => setTamfiMember(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>No</span>
                </label>
              </div>
            </div>
          </div>
          {tamfiMember === "No" && (
            <div className="survey-form-group">
              <label>
                Kindly choose atleast one reason <span className="star">*</span>
              </label>
              <div className="check-div">
                <div class="checkbox-wrapper-1">
                  <input
                    id="cost"
                    class="substituted"
                    type="checkbox"
                    value="Membership Cost"
                    checked={notInTAMFIReason.includes("Membership Cost")}
                    onChange={handleCheckboxNotInTAMFIReasonChange}
                  />
                  <label for="cost">Membership Cost</label>
                </div>
                <div class="checkbox-wrapper-1">
                  <input
                    id="benefits-awareness"
                    class="substituted"
                    type="checkbox"
                    value="Limited awareness of benefits"
                    checked={notInTAMFIReason.includes(
                      "Limited awareness of benefits",
                    )}
                    onChange={handleCheckboxNotInTAMFIReasonChange}
                  />
                  <label for="benefits-awareness">
                    Limited awareness of benefits
                  </label>
                </div>
              </div>
              <div className="check-div">
                <div class="checkbox-wrapper-1">
                  <input
                    id="direct-value"
                    class="substituted"
                    type="checkbox"
                    value="Perceived lack of direct value"
                    checked={notInTAMFIReason.includes(
                      "Perceived lack of direct value",
                    )}
                    onChange={handleCheckboxNotInTAMFIReasonChange}
                  />
                  <label for="direct-value">
                    Perceived lack of direct value
                  </label>
                </div>
                <div class="checkbox-wrapper-1">
                  <input
                    id="transparency"
                    class="substituted"
                    type="checkbox"
                    value="Transparency concerns"
                    checked={notInTAMFIReason.includes("Transparency concerns")}
                    onChange={handleCheckboxNotInTAMFIReasonChange}
                  />
                  <label for="transparency">Transparency concerns</label>
                </div>
              </div>
            </div>
          )}
          <div className="survey-form-group">
            <div className="survey-form-group">
              <label>
                What interest rate do you charge ?{" "}
                <span className="star">*</span>
              </label>
              <input
                type="text"
                value={interest}
                onChange={(e) => setInterest(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className={`form-step ${step === 5 ? `active ${direction}` : ""}`}>
          <div className="survey-form-group">
            <label>
              Do you have a Data Protection Certificate ?{" "}
              <span className="star">*</span>
            </label>
            <div className="radio-div">
              <div className="radio-wrapper-3">
                <label htmlFor="radio-dpc-Yes">
                  <input
                    id="radio-dpc-Yes"
                    type="radio"
                    name="radio-dpc"
                    value="Yes"
                    checked={haveDPC === "Yes"}
                    onChange={(e) => setHaveDPC(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>Yes</span>
                </label>
              </div>
              <div className="radio-wrapper-3">
                <label htmlFor="radio-dpc-No">
                  <input
                    id="radio-dpc-No"
                    type="radio"
                    name="radio-dpc"
                    value="No"
                    checked={haveDPC === "No"}
                    onChange={(e) => setHaveDPC(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>No</span>
                </label>
              </div>
            </div>
          </div>
          {haveDPC === "Yes" && (
            <div className="survey-form-group">
              <label>
                Upload Certificate <span className="option">(Optional)</span>
              </label>
              <input
                type="file"
                name="dpc"
                onChange={(e) => setDPC(e.target.files[0])}
              />
            </div>
          )}
          <div className="survey-form-group">
            <label>
              Do you currently have an account with any financial institution ?{" "}
              <span className="star">*</span>
            </label>
            <div className="radio-div">
              <div className="radio-wrapper-3">
                <label htmlFor="radio-financial-account-yes">
                  <input
                    id="radio-financial-account-yes"
                    type="radio"
                    name="radio-financial-account"
                    value="Yes"
                    checked={financialAccount === "Yes"}
                    onChange={(e) => setFinancialAccount(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>Yes</span>
                </label>
              </div>
              <div className="radio-wrapper-3">
                <label htmlFor="radio-financial-account-no">
                  <input
                    id="radio-financial-account-no"
                    type="radio"
                    name="radio-financial-account"
                    value="No"
                    checked={financialAccount === "No"}
                    onChange={(e) => setFinancialAccount(e.target.value)}
                  />
                  <span className="circle"></span>
                  <span>No</span>
                </label>
              </div>
            </div>
          </div>
          {financialAccount === "Yes" && (
            <>
              <div className="survey-bank-group">
                <label>
                  If yes, where ? <span className="star">*</span>
                </label>

                {institutions.map((institution, index) => (
                  <>
                    <select
                      name={`bankName-${index}`}
                      value={institution}
                      onChange={(e) =>
                        handleChangeInstitution(index, e.target.value)
                      }
                      required
                    >
                      <option value="">Choose Financial Institution</option>
                      {banks.map((bank) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.bank_name}
                        </option>
                      ))}
                    </select>

                    <button
                      type="button"
                      className="remove-bank-btn"
                      onClick={() => removeInstitution(index)}
                    >
                      Remove
                    </button>
                  </>
                ))}
              </div>

              <button
                type="button"
                className="survey-nav-btn"
                onClick={addInstitution}
              >
                Add Financial Institution
              </button>
            </>
          )}
        </div>

        {/* Navigation Buttons */}
        <div className="form-navigation">
          {step > 1 && (
            <button type="button" onClick={goPrev} className="survey-nav-btn">
              Previous
            </button>
          )}
          {step < 5 && (
            <button type="button" onClick={goNext} className="survey-nav-btn">
              Next
            </button>
          )}
        </div>
        {step === 5 && (
          <button
            type="submit"
            disabled={isVerifying}
            className="survey-submit-btn"
          >
            {isVerifying ? (
              <div className="overlay">
                <img
                  src="images/citIlogo.jpg"
                  alt="Loading..."
                  className="survey-loading-logo"
                />
              </div>
            ) : (
              "Submit"
            )}
          </button>
        )}

        <ToastContainer />
      </form>
    </div>
  );
}

export default MFISurveyForm;
